import type { AnError } from '@atlassian/jira-servicedesk-common/src/model/error/anerror';
import type { SummaryPage } from '../../../model';

// RETRIEVE
export const RETRIEVE = 'state.actions.retrieve.RETRIEVE' as const;

export type SummaryLoadRequestAction = {
	type: typeof RETRIEVE;
};

export const summaryLoadRequest = (): SummaryLoadRequestAction => ({
	type: RETRIEVE,
});

// RETRIEVE_SUCCESS
export const RETRIEVE_SUCCESS = 'state.actions.retrieve.RETRIEVE_SUCCESS' as const;

export type SummaryLoadSuccessAction = {
	type: typeof RETRIEVE_SUCCESS;
	payload: SummaryPage;
};

export const summaryLoadSuccess = (response: SummaryPage): SummaryLoadSuccessAction => ({
	type: RETRIEVE_SUCCESS,
	payload: response,
});

// RETRIEVE_FAILURE

export const RETRIEVE_FAILURE = 'state.actions.retrieve.RETRIEVE_FAILURE' as const;

export type SummaryLoadFailureAction = {
	type: typeof RETRIEVE_FAILURE;
	payload: {
		error: AnError;
	};
};

export const summaryLoadFailure = (error: AnError): SummaryLoadFailureAction => ({
	type: RETRIEVE_FAILURE,
	payload: {
		error,
	},
});
